import React, { useContext } from 'react'
import { Route, Routes } from 'react-router-dom'

import NotFound from '../NotFound'
import { AbilityContext } from '../../components/Ability'
import LeadPage from './Features/Lead'
import PipelinePage from './Features/Pipeline'


const CRMPage = () => {
  const ability = useContext(AbilityContext)

  return (
    <Routes>
      <Route
        path="/pipeline"
        element={
          ability.can('manage', 'CRM', 'pipeline') ? < PipelinePage /> : <NotFound />
        }
      />
      <Route
        path="/lead/*"
        element={<LeadPage />}
      />
    </Routes>
  )
}

export default CRMPage
